import { useDispatch } from "react-redux"
import { Brand, setSelectedBrandId } from "@/redux/slices/brandSlice"
import { RootState } from "@/redux/store"
import LetterAvatar from "@/components/Avatar/LetterAvatar"
import CustomAutoComplete from "@/components/Select/CustomAutoComplete"
import { useAppSelector } from "@/lib/hooks"

export function BrandSelect() {
  const dispatch = useDispatch()
  const { brands, selectedBrandId, loading } = useAppSelector(
    (state: RootState) => state.brand
  )

  return (
    <CustomAutoComplete
      {...({ loading } as any)}
      label="Select Brand"
      options={brands}
      optionLabel={(option: Brand) => option.name}
      optionValue="id"
      selectedValue={selectedBrandId}
      onChange={(newId: number) => dispatch(setSelectedBrandId(newId))}
      onInputChange={() => {}}
      renderOptionContent={(option: Brand) => (
        <LetterAvatar name={option.name} key={option.id} />
      )}
    />
  )
}
